unit CRM.Enumerations;

interface

{$SCOPEDENUMS ON}
{$IFNDEF PAS2JS}

Uses
  System.SysUtils,
  Aurelius.Mapping.Attributes;
{$ENDIF}

type
{$IFNDEF PAS2JS}
  [Enumeration(TEnumMappingType.emString, 'Active,GoneAway')]
{$ENDIF}
  TPersonStatus = (Active,GoneAway);

{$IFNDEF PAS2JS}
  [Enumeration(TEnumMappingType.emString, 'Invoice, CreditNote, ProForma')]
{$ENDIF}
  TInvoiceKind = (Invoice, CreditNote, ProForma);


{$IFNDEF PAS2JS}
  [Enumeration(TEnumMappingType.emString, 'BACS,Cheque')]
{$ENDIF}
  TPaymentMethod = (BACS, Cheque);

{$IFNDEF PAS2JS}
  [Enumeration(TEnumMappingType.emString, 'New,Reconciled,Success,Failed,Cancelled')]
{$ENDIF}
  TPaymentState = (New, Reconciled, Success, Failed, Cancelled);

{$IFNDEF PAS2JS}
  [Enumeration(TEnumMappingType.emString, 'Payment,Refund')]
{$ENDIF}
  TPaymentKind = (Payment, Refund);

{$IFNDEF PAS2JS}
  [Enumeration(TEnumMappingType.emString, 'Other,Deposit,Balance')]
{$ENDIF}
  TPaymentLevel = (Other, Deposit, Balance);


const
  Payment_State: Array [TPaymentState] Of String = ('New', 'Reconciled', 'Success', 'Failed', 'Cancelled');
  Payment_Type: Array [TPaymentKind] Of String = ('Payment', 'Refund');
  Payment_Level: Array [TPaymentLevel] Of String = ('Other', 'Deposit', 'Balance');
  Payment_Method: array [TPaymentMethod] of string = ('BACS', 'Cheque');

  Payment_Level_Description: Array [TPaymentLevel] Of String = ('Payment', 'Deposit Payment', 'Balance Payment');

implementation

end.
